import clsx from "clsx";
import {
  Box,
  makeStyles,
  Typography,
  Card,
  Button,
  FormLabel,
} from "@material-ui/core";
import Page from "src/components/Page";
import React from "react";
import { FileIcon, defaultStyles } from "react-file-icon";
import SvgIcon from "@material-ui/core/SvgIcon";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { apiDownloadFileData, apiEndpoints } from "src/utils/api/api";
import fileDownload from "js-file-download";
import AccessibilityDecl from "src/components/common/AccessibilityDecl";
import AccessibilityDeclarationFedp from "src/components/common/AccessibilityDeclFedp";
import { connect } from "react-redux";
import { getSystemLabel } from "src/constant/Messages";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
}));

const AccessibilityView = ({ globalData }) => {
  const classes = useStyles();

  // let accDeclFileName = `Deklaracja dostępności systemu portalu KM ${kmSystemLabels.programShortcut[systemInfo.fundProgram]}.docx`;

  console.log(globalData.systemInfo);

  const handleFileDownload = (documentKey, fileName) => {
    apiDownloadFileData(
      `${apiEndpoints.downloadSystemDocument.path}${documentKey}`,
      true
    )
      .then((result) => {
        fileDownload(result, fileName);
      })
      .catch((error) => {});
  };

  return (
    <Page className={classes.root} title="Deklaracja dostępności">
      <Box mt={3}>
        <Card className={clsx(classes.root)}>
          <Box display="flex" flexDirection="column">
            <Box>
              <Typography
                color="textPrimary"
                component="h1"
                variant="h2"
                align="center"
                paragraph
                id="a11y-deklaracja"
              >
                Deklaracja dostępności
              </Typography>
              {globalData.systemInfo.fundProgram == "fedp2127" ? (
                <AccessibilityDeclarationFedp></AccessibilityDeclarationFedp>
              ) : (
                <AccessibilityDecl></AccessibilityDecl>
              )}
            </Box>

            <FormLabel>Dokumenty do pobrania:</FormLabel>

            <Box p={2} display="flex" flexWrap="wrap">
              <Box p={1}>
                <SvgIcon className={classes.fileicon}>
                  <FileIcon extension={"docx"} {...defaultStyles["docx"]} />
                </SvgIcon>
                <Typography className={classes.filename} display="inline">
                  {`Deklaracja dostępności systemu portalu KM ${getSystemLabel(
                    "programShortcut",
                    globalData.systemInfo
                  )}.docx`}
                </Typography>
              </Box>

              <Box ml={2} p={1}>
                <Button
                  title={`Pobranie Deklaracji dostępności systemu portalu KM ${getSystemLabel(
                    "programShortcut",
                    globalData.systemInfo
                  )} w formie pliku DOCX`}
                  aria-label={`Pobranie Deklaracji dostępności systemu portalu KM ${getSystemLabel(
                    "programShortcut",
                    globalData.systemInfo
                  )} w formie pliku DOCX`}
                  variant="contained"
                  color="default"
                  className={classes.button}
                  startIcon={<CloudDownloadIcon />}
                  onClick={() =>
                    handleFileDownload(
                      "accessibility_declaration",
                      `Deklaracja dostępności systemu portalu KM ${getSystemLabel(
                        "programShortcut",
                        globalData.systemInfo
                      )}.docx`
                    )
                  }
                >
                  Pobierz plik
                </Button>
              </Box>
            </Box>
          </Box>
        </Card>
      </Box>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

export default connect(mapStateToProps, null)(AccessibilityView);
